import { Link } from "react-router-dom";
import { C } from "../constants";
import VaultLogo from "./VaultLogo";

export default function Footer() {
  return (
    <footer style={{ background: "#1A2332", padding: "44px 24px 22px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 28, marginBottom: 36 }}>
          <div>
            <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, textDecoration: "none" }}>
              <VaultLogo size={26} />
              <span style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 18, color: "#fff" }}>
                Safe<span style={{ color: C.blue }}>Zapp</span>
              </span>
            </Link>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 12.5, color: "rgba(255,255,255,0.4)", lineHeight: 1.6 }}>
              Secure & Supervised Messaging.<br />Built in Melbourne, Australia.
            </p>
          </div>
          {[
            ["Product", [["/features", "Features"], ["/how-it-works", "How It Works"], ["/pricing", "Pricing"], ["/demo", "Demo & Tutorials"]]],
            ["Who It's For", [["/for-approvers", "Approvers"], ["/for-users", "Users"], ["/about", "About"]]],
            ["Legal", [["/compliance", "Compliance"], ["/privacy", "Privacy Policy"], ["/terms", "Terms of Service"], ["/delete-account", "Delete Account"]]],
            ["Connect", [["/contact", "Contact"], ["/blog", "Blog"]]],
          ].map(([title, items]) => (
            <div key={title}>
              <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 13.5, color: "#fff", marginBottom: 10 }}>{title}</div>
              {items.map(([to, label]) => (
                <Link key={label} to={to} style={{
                  fontFamily: "'Nunito', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.45)",
                  marginBottom: 7, display: "block", textDecoration: "none", transition: "color 0.2s"
                }}
                  onMouseEnter={e => e.currentTarget.style.color = "rgba(255,255,255,0.8)"}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.45)"}
                >{label}</Link>
              ))}
            </div>
          ))}
        </div>
        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 18,
          fontFamily: "'Nunito', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.25)", textAlign: "center"
        }}>
          © 2026 SafeZapp. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
